export default "__VITE_ASSET__2b53ea26__"